/**
 * Gets selling plan groups by Shopify product ID from Recharge API
 * @param {string} productId Shopify product id
 * @returns
 */

// eslint-disable-next-line
export const getSellingPlanGroupsByProductId = productId => {
	const rechargePath = `selling_plan_groups?include=product&external_product_id=${ productId }`;

	return fetch(`/api/recharge?path=${ encodeURIComponent(rechargePath) }`)
		.then(res => {
			return res.json();
		})
		.then(data => {
			const {
				selling_plan_groups: sellingPlanGroups,
			} = data;

			return sellingPlanGroups?.length > 0 ? sellingPlanGroups[0] : null;
		});
};
